import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormBodyDirective } from './form-body.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FormBodyDirective
  ],
  exports: [
    FormBodyDirective
  ]
})
export class FormBodyModule { }
